import React, { Component,useState,useEffect } from 'react';
import CountUp from 'react-countup';
import Datepicker from '../../common/datepicker';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from '../../../config.js'
import DynamicTable from '../../DynamicTable.js';





const Leave = (props) => {
const sparkline1 = React.createRef();
const sparkline2 = React.createRef();
const sparkline3 = React.createRef();
const sparkline4 = React.createRef();

const [formData, setFormData] = useState({
from_date: '',
to_date: '',
user_id:'5',
});
const [options, setData] = useState([]); 
const [table, setTable] = useState([]); 
const [settype, setType] = useState([]);
const [setcount, setCount] = useState([]);
const [setcompoff, setComp] = useState([]);
const [setcompcount, setCompCount] = useState([]);

const [sample, setlist] = useState([]); 

const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);

const [user_info, setinfo] = useState([]);





const handleChange = (e) => {
  
const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
const imageStyle = {
  width: '300px',
  height: 'auto',
  borderRadius: '10px',
}








// useEffect(async() => {
//   setLoading(true);
//   setError(null); // Clear any previous errors
//   try {
//     const response = await fetch('http://127.0.0.1:8000/api/user_info');
//     if (!response.ok) {
//       throw new Error('Network response was not ok');
//     }
//     const result = await response.json();
//     console.log("haiiiiii")
//     console.log(result.data);
//       setinfo(result.data[0]);
//   } catch (err) {
//     setError(err.message);
//   } finally {
//     setLoading(false);
//   }
// },[]);

useEffect(() => {
  axios.get(API_BASE_URL + '/user_info', {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
  })

    // .then(res =>console.log(res.data))
    .then(res => setinfo(res.data))
    .catch(err => console.log(err));
}, [])

useEffect(() => {
  const token = '302|whIIai9tSr5YxTndtqSzWUcplm0aDnIfYuWeFZyra9ac3284'; 
  
  axios
    .get(API_BASE_URL+'/leave_type', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {
      setTable(response.data.data.table);
      setCount(response.data.data);

     console.log(response.data.data.sl);
    
      setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
}, []);



useEffect(() => {
  
  axios
    .get(API_BASE_URL+'/leavetypelist', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {
      setType(response.data.data.leave_type);
     
    
      setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
}, []);






const compoffchangeoption= async(dateval) => {
  setLoading(true);
  setError(null); // Clear any previous errors
  try {
  
    const response = await axios.post(API_BASE_URL +'/comp_off', {'from_date':dateval}, {
     
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

        'Content-Type': 'application/json', // Ensure JSON data is sent
      },
    });
  
    // console.log("Response received:");
    console.log(response.data.data.count);
  
    setComp(response.data.data.comp_table);
    setCompCount(response.data.data.count);

  } catch (err) {
    // Handle errors (both network and server)
    setError(err.response ? err.response.data.message : err.message);
  } finally {
    setLoading(false); // Stop loading spinner or indicator
  }
  
};


const handleSubmit =  async (e) => {

e.preventDefault(); // Prevent the default form submission

console.log('Form submitted:', formData);



axios.post(API_BASE_URL+'/add_leave' ,formData, {
  headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

  'Content-Type': 'application/json', // Ensure JSON data is sent
},
}).then(response => {
   //  console.log(response.data);
        //  console.log(response.data.message);
        // })
        var status =response.data.status;
            if (status=='success')
            {
                toast.success(response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
                    setTimeout(() => {
                      window.location.reload(); // Reload the page after delay
                    }, 3000);
                   
            }
           else if (status=='error')
              {
                  toast.error(response.data.message, {
                      position: "bottom-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                      });
                      // setTimeout(() => {
                      //   window.location.reload(); // Reload the page after delay
                      // }, 3000);
                     
              }
           
        }).catch(error => {
        
            // console.log(error);
            // console.log(error.response.data.message);
            toast.error(error.response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
         });




};



const call=async(event) => { 
  const value= event.target.value;

  compoffchangeoption(value);
}







const { fixNavbar, statisticsOpen, statisticsClose } = props;

return (
<>
<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<ToastContainer/>
<div className="container-fluid">



<div className="row">
<div className="col-lg-3 col-md-4">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available SL</span>
<h3 className="mb-0">

<span className="counter">	<CountUp  /> {setcount.sl}</span>
</h3>
</div>
<div className="w_chart">
<div id="mini-bar-chart1" className="mini-bar-chart" />
</div>
</div>
</div>
{/* 
<div className="w_chart">
<span
ref={sparkline1}
id="mini-bar-chart1"
className="mini-bar-chart"
></span>
</div>
*/}
</div>
<div className="col-lg-3 col-md-6">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available CL</span>
<h3 className="mb-0">
{/* /<CountUp end={user_info.leave_available} /> */}
<span >{setcount.cl}</span>
</h3>
</div>
<div className="w_chart">
<span
ref={sparkline2}
id="mini-bar-chart2"
className="mini-bar-chart"
/>
</div>
</div>
</div>
</div>
<div className="col-lg-3 col-md-6">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available Paternity</span>
<h3 className="mb-0 counter">	<CountUp end={setcount.pl} />{setcount.pl}</h3>
</div>
<div className="w_chart">
<span
ref={sparkline3}
id="mini-bar-chart3"
className="mini-bar-chart"
/>
</div>
</div>
</div>
</div>

</div>

<form onSubmit={handleSubmit}>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix">
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Leave Type</label><span className="form-required">*</span>



<select  className="form-control custom-select" id="leave_type"   name='leave_type' value={formData.leave_type} onChange={handleChange}>
        <option value="" disabled>Select Leave Type</option>
        <option></option>

        {settype.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

</div>
</div>
<div className="col-lg-4 col-md-12">
<label>From Date</label><span className="form-required">*</span>

<div className="form-group">
<input type='hidden' name="user_id" value={formData.user_id}
 onChange={handleChange}/>
  <input type='date' className='form-control' name="from_date" placeholder='Select Date' value={formData.from_date}
 onChange={(e)=>{handleChange(e);compoffchangeoption(e.target.value)}}/>
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-lg-4 col-md-12">
<label>To Date</label><span className="form-required">*</span>

<div className="form-group">



<input type='date'  className='form-control' name="to_date" value={formData.to_date}
 onChange={handleChange} />
{/* <Datepicker name="todate" value={formData.todate}
onChange={handleChange}></Datepicker> */}
{/* <div className="input-"  name="to_date" value={formData.to_date}
onChange={handleChange}>


</div> */}
</div>
</div>


{formData.leave_type==5 && 
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Select Compensatory Off  ({setcompcount})</label><span className="form-required">*</span>



<select  className="form-control custom-select" id="combooff_days"   name='combooff_days' value={formData.combooff_days} onChange={handleChange}>
        <option value="" disabled> Comp Off</option>
       < option></option>
       {setcompoff.length!=0 &&
       ( setcompoff.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        )))}
      </select>

</div>
</div>
}

<div className="col-lg-12 col-md-12">
<label>Reason</label><span className="form-required">*</span>

<div className="form-group">
<textarea
rows={4}
type="text"
className="form-control"
placeholder="Reason"
name="reason" value={formData.reason}
onChange={handleChange}
/>
</div>
</div>
</div>
<button type="submit" className="btn btn-round btn-primary">
Save
</button>

</div>

</div>


</div>

</form>

</div>
</div>
<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
<div className="card-header">
<h3 className="card-title">Leave List</h3>

</div>
<div className="card-body">
<div className="table-responsive">
<DynamicTable data={table} />
{/* <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
<thead>
<tr>
<th>Name</th>
<th>Employee ID</th>
<th>Leave Type</th>
<th>Applied On</th>
<th>Reason</th>
<th>Comboff day</th>
<th>Status</th>
</tr>
</thead>
 {<tbody>
  
{  sample.map((leave,index) => {

let statusMessage;
if (leave.hr_status ==2) {
  statusMessage = 'Approval';
} else if (leave.hr_status ==1) {
  statusMessage = ' Pending';
}
return <tr key={index}>

<td className="d-flex">
<span
className="avatar avatar-indigo"
data-toggle="tooltip"
data-original-title="Avatar Name"
>
<img src='assets/images/ok.svg' width={150} />

</span>
<div className="ml-3">
<h6 className="mb-0">{leave.first_name}</h6>
<span className="text-muted">
{leave.email}																	</span>
</div>
</td>
<td>
<span>{leave.employee_id}</span>
</td>
<td>
<span>{leave.type_name}</span>
</td>
<td>{leave.applied_on}</td>
<td>{leave.reason}</td>
<td></td>
<td>{statusMessage}</td>
</tr>

})
}

</tbody>  }
</table> */}
</div>
</div>
</div>
</div>

</div>
</div>
</div>

</div>
</div>

</>
);
}


export default Leave;